module.exports = __webpack_public_path__ + "img/Shape Copy.c27a1cac.svg";